import { HttpInterceptorFn, HttpErrorResponse, HttpEvent, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppToastService } from '../services/app-toast.service';
import { PostHogService } from '../../shared/services/post-hog.service';
import { v4 as uuidv4 } from 'uuid';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const appToast = inject(AppToastService);
  const token = localStorage.getItem('tif-access-token');
  const postHogService = inject(PostHogService);

  // Update logic to check against environment.api and environment.graphql
  const apiUrl = new URL(environment.api);
  const graphqlUrl = new URL(environment.graphql);
  const reqUrl = new URL(req.url);
  const shouldIncludeToken = reqUrl.href.startsWith(apiUrl.href) || reqUrl.href.startsWith(graphqlUrl.href);
  
  const reqWithBearerToken = shouldIncludeToken && token ? req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
      'tif-user-data': localStorage.getItem('tif-user-data') || '',
      'x-tif-txn-id': uuidv4()
    },
  }) : req;

  return next(reqWithBearerToken).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // Check for quota errors
        if (event.body && event.body.errors) {
          for (const error of event.body.errors) {
            if (error.message === 'Invalid or expired Firebase token') {
              postHogService.reset();
              router.navigate(['/login']);
            }
            console.log(error);
            if (error.message === 'Quota exceeded') {
              // Show both toasts
              appToast.showToast({
                message: 'You\'ve exceeded your subscription limit for this feature. Click here to check usage.',
                bgColor: 'bg-[#FEF3F2]',
                borderColor: 'border-[#FDA29B]',
                iconSrc: 'assets/icons/alert.svg'
              });
            }
          }
        }
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        postHogService.reset();
        router.navigate(['/login']);
      }
      
      // Check for quota errors in error response
      const errors = error?.error?.errors;
      if (Array.isArray(errors)) {
        const quotaError = errors.find((err: any) => err.message === 'Quota exceeded');
        if (quotaError) {
          appToast.showToast({
            message: 'You\'ve exceeded your subscription limit for this feature. <a href="/usage" class="underline cursor-pointer">Click here</a> to check usage.',
            bgColor: 'bg-[#FEF3F2]',
            borderColor: 'border-[#FDA29B]',
            iconSrc: 'assets/icons/alert.svg'
          });
        }
      }
      
      return throwError(() => error);
    })
  );
};
